<template>
    <div class="add-address-component">
        <div class="form-label-group">
            <input
                id="add_first_name"
                type="text"
                :class="'form-control' + (formErrors?.first_name ? ' is-invalid' : '')"
                name="add_first_name"
                placeholder="First Name"
                required
                v-model="first_name"
            />
            <label for="add_first_name">First Name</label>
            <span class="invalid-feedback d-block" role="alert" v-if="formErrors?.first_name">
                {{ formErrors.first_name[0] }}
            </span>
        </div>
        <div class="form-label-group">
            <input
                id="add_last_name"
                type="text"
                :class="'form-control' + (formErrors?.last_name ? ' is-invalid' : '')"
                name="add_last_name"
                placeholder="Last Name"
                required
                v-model="last_name"
            />
            <label for="add_last_name">Last Name</label>
            <span class="invalid-feedback d-block" role="alert" v-if="formErrors?.last_name">
                {{ formErrors.last_name[0] }}
            </span>
        </div>
        <div class="form-label-group">
            <input
                id="add_contact_number"
                type="text"
                :class="
                    'form-control' +
                        (formErrors?.contact_number
                            ? ' is-invalid'
                            : '')
                "
                name="add_contact_number"
                placeholder="Telephone number"
                required
                v-model="contact_number"
            />
            <label for="add_contact_number">Telephone number</label>
            <span
                class="invalid-feedback d-block"
                role="alert"
                v-if="formErrors?.contact_number"
            >
                {{ formErrors.contact_number[0] }}
            </span>
        </div>

        <div class="form-label-group">
            <input
                id="add_company_name"
                type="text"
                :class="
                    'form-control' +
                        (formErrors?.company_name
                            ? ' is-invalid'
                            : '')
                "
                name="add_company_name"
                placeholder="Company"
                v-model="company_name"
            />
            <label for="add_company_name">Company</label>
            <span
                class="invalid-feedback d-block"
                role="alert"
                v-if="formErrors?.company_name"
            >
                {{ formErrors.company_name[0] }}
            </span>
        </div>

        <loqate-address-lookup-component
            v-if="addingAddressId"
            prefix="add_"
            :address-id="addingAddressId"
            :selected-country="country_iso2"
        />

        <div class="form-label-group">
            <input
                id="add_address_1"
                type="text"
                :class="
                    'form-control' +
                        (formErrors?.address_1
                            ? ' is-invalid'
                            : '')
                "
                name="add_address_1"
                placeholder="Address 1"
                required
                v-model="address_1"
            />
            <label for="add_address_1">Address 1</label>
            <span
                class="invalid-feedback d-block"
                role="alert"
                v-if="formErrors?.address_1"
            >
                {{ formErrors.address_1[0] }}
            </span>
        </div>

        <div class="form-label-group">
            <input
                id="add_address_2"
                type="text"
                :class="
                    'form-control' +
                        (formErrors?.address_2
                            ? ' is-invalid'
                            : '')
                "
                name="add_address_2"
                placeholder="Address 2"
                v-model="address_2"
            />
            <label for="add_address_2">Address 2</label>
            <span
                class="invalid-feedback d-block"
                role="alert"
                v-if="formErrors?.address_2"
            >
                {{ formErrors.address_2[0] }}
            </span>
        </div>

        <div class="form-label-group">
            <input
                id="add_city"
                type="text"
                :class="
                    'form-control' +
                        (formErrors?.city
                            ? ' is-invalid'
                            : '')
                "
                name="add_city"
                placeholder="City"
                required
                v-model="city"
            />
            <label for="add_city">Town / City</label>
            <span
                class="invalid-feedback d-block"
                role="alert"
                v-if="formErrors?.city"
            >
                {{ formErrors.city[0] }}
            </span>
        </div>

        <div class="form-label-group">
            <input
                id="add_county"
                type="text"
                :class="
                    'form-control' +
                        (formErrors?.county
                            ? ' is-invalid'
                            : '')
                "
                name="add_county"
                placeholder="County"
                v-model="county"
            />
            <label for="county">County</label>
            <span
                class="invalid-feedback d-block"
                role="alert"
                v-if="formErrors?.county"
            >
                {{ formErrors.county[0] }}
            </span>
        </div>

        <div class="form-label-group">
            <input
                id="add_postcode"
                type="text"
                :class="
                    'form-control' +
                        (formErrors?.postcode
                            ? ' is-invalid'
                            : '')
                "
                name="add_postcode"
                placeholder="Postcode"
                required
                v-model="postcode"
            />
            <label for="postcode">Postcode</label>
            <span
                class="invalid-feedback d-block"
                role="alert"
                v-if="formErrors?.postcode"
            >
                {{ formErrors.postcode[0] }}
            </span>
        </div>

        <div class="form-group" v-if="countries">
            <div class="styled-dropdown">
                <select
                    id="add_country_iso2"
                    :class="
                        'form-control' +
                            (formErrors?.country_iso2
                                ? ' is-invalid'
                                : '')
                    "
                    name="add_country_iso2"
                    required
                    v-model="country_iso2"
                >
                    <option :value="null">
                        Select Country
                    </option>
                    <option
                        v-for="(country, iso2) in countries"
                        v-bind:key="iso2"
                        v-bind:value="iso2"
                    >
                        {{ country }}
                    </option>
                </select>
                <img src="/img/icons/down-arrow.svg" alt="" />
            </div>
            <span
                class="invalid-feedback d-block"
                role="alert"
                v-if="formErrors?.country_iso2"
            >
                {{ formErrors.country_iso2[0] }}
            </span>
        </div>

        <div v-if="error" class="alert alert-danger">
            {{ error }}
        </div>

        <div
            v-if="loading"
            class="d-flex align-items-center text-center justify-content-center"
        >
            <div class="spinner-border" role="status" aria-hidden="true"></div>
        </div>

        <button type="button" class="btn btn-primary" v-on:click="addAddress">
            Add Address
        </button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            first_name: null,
            last_name: null,
            contact_number: null,
            company_name: null,
            address_1: null,
            address_2: null,
            city: null,
            county: null,
            postcode: null,
            country_iso2: null,
            countries: null,
            error: false,
            formErrors: {},
            addressIdentifier: null,
            addingAddressId: null,
        };
    },
    watch: {
        loading: function(val) {
            document.querySelector("button#continue").disabled = val;
        }
    },
    mounted() {
        this.$root.$on('addressAdd', (addressIdentifier, addressId) => {
            this.addingAddressId = addressId;
            this.setAddressIdentifier(addressIdentifier);
            this.getCountries(addressId);
        });
    },
    methods: {
        setAddressIdentifier(addressIdentifier) {
            this.addressIdentifier = addressIdentifier;
        },
        getCountries(addressId) {
            let url = '/api/v1/address/countries';

            if (addressId) {
                url += `?address=${addressId}`;
            }

            axios
                .get(url)
                .then(res => {
                    if (res.data && res.data.success) {
                        this.countries = res.data.countries;
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(res => {
                    this.loading = false;
                });
        },
        addAddress() {
            this.loading = true;
            axios
                .post("/api/v1/address/add", {
                    first_name: this.first_name,
                    last_name: this.last_name,
                    contact_number: this.contact_number,
                    company_name: this.company_name,
                    address_1: this.address_1,
                    address_2: this.address_2,
                    city: this.city,
                    county: this.county,
                    postcode: this.postcode,
                    country_iso2: this.country_iso2
                })
                .then(res => {
                    this.error = false;
                    this.formErrors = null;
                    if (res.data && res.data.success) {
                        $('#add-address-modal').modal('hide');

                        // clear form
                        this.first_name = null;
                        this.last_name = null;
                        this.contact_number = null;
                        this.company_name = null;
                        this.address_1 = null;
                        this.address_2 = null;
                        this.city = null;
                        this.county = null;
                        this.postcode = null;
                        this.country_iso2 = null;
                        this.$root.$emit(
                            "addressAdded",
                            res.data.new_address_id,
                            this.addressIdentifier
                        );
                    } else {
                        this.error =
                            "The information you entered was incorrect, please try again.";
                    }
                })
                .catch(error => {
                    this.formErrors = error.response.data.errors;
                    this.error = "Please fix form validation errors.";
                })
                .finally(res => {
                    this.loading = false;
                });
        }
    }
};
</script>
